module.exports = __webpack_public_path__ + "static/media/TriviaIcon.35823bbc.png";